import { render, staticRenderFns } from "./DateAnswer.vue?vue&type=template&id=23489776&"
import script from "./DateAnswer.vue?vue&type=script&lang=ts&"
export * from "./DateAnswer.vue?vue&type=script&lang=ts&"
import style0 from "./DateAnswer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports